'use strict';
var basecustomMain = require('app_custom_vinfast_ui/global/customMain');

/**
 * Show a spinner inside a given element
 * @param {element} $target - Element to block by the veil and spinner.
 *                            Pass body to block the whole page.
 */
function addSpinner($target) {
    var $veil = $('<div class="veil"><div class="underlay"></div></div>');
    $veil.append('<div class="spinner"><div class="dot1"></div><div class="dot2"></div></div>');
    if ($target.get(0).tagName === 'IMG') {
        $target.after($veil);
        $veil.css({ width: $target.width(), height: $target.height() });
        if ($target.parent().css('position') === 'static') {
            $target.parent().css('position', 'relative');
        }
    } else {
        $target.append($veil);
        if ($target.css('position') === 'static') {
            $target.parent().css('position', 'relative');
            $target.parent().addClass('veiled');
        }
        if ($target.get(0).tagName === 'BODY') {
            $veil.find('.spinner').css('position', 'fixed');
        }
    }
    $veil.click(function (e) {
        e.stopPropagation();
    });
}

/**
 * Remove existing spinner
 * @param  {element} $veil - jQuery pointer to the veil element
 */
function removeSpinner($veil) {
    if ($veil.parent().hasClass('veiled')) {
        $veil.parent().css('position', '');
        $veil.parent().removeClass('veiled');
    }
    $veil.off('click');
    $veil.remove();
}

/*
// element level spinner:
if ( !$.isFunction($.fn.spinner) ) {
    $.fn.spinner = function () {
        var $element = $(this);
        var Fn = function () {
            this.start = function () {
                if ($element.length) {
                    addSpinner($element);
                }
            };
            this.stop = function () {
                if ($element.length) {
                    var $veil = $('.veil');
                    removeSpinner($veil);
                }
            };
        };
        return new Fn();
    };

    // page-level spinner:
    $.spinner = function () {
        var Fn = function () {
            this.start = function () {
                addSpinner($('body'));
            };
            this.stop = function () {
                removeSpinner($('.veil'));
            };
        };
        return new Fn();
    };
}
*/

/*Language sidemenu*/
$(".nav-item-multilanguage").click(function (e) {
    $(".menu-global").fadeIn(500);
});

// Close menu languages.
$(".menu-global").click(function (e) {
    $(".menu-global").fadeOut(500);
});
$(".menu-global .button-closed").click(function (e) {
    $(".menu-global").fadeOut(500);
});

var getScrollbarWidth = function() {
    if (document.getElementById('scrollbarWidthID')) document.getElementById('scrollbarWidthID').remove();
    var div = document.createElement("div");
    div.setAttribute("id", "scrollbarWidthID");
    div.style.overflow = "scroll";
    div.style.visibility = "hidden";
    div.style.position = 'absolute';
    div.style.width = '100px';
    div.style.height = '100px';
    document.body.appendChild(div);
    return div.offsetWidth - div.clientWidth;
};

var scrollbarWidth = getScrollbarWidth();
var style = document.createElement('style');
style.innerHTML = '.noScroll{padding-right: ' + scrollbarWidth + 'px}.mouseover_rightpannel_attributes_hover{padding-right: ' + scrollbarWidth + 'px}';
document.head.appendChild(style);

$(".nav-item-multilanguage").click(function (e) {
    if ($('#allinonemodal.show').length) {
        $('#allinonemodal').modal('hide');
        $(".menu-global").attr('allinonemodal', 'show');
    }
    $(".menu-global").fadeIn(500);
    $('body').addClass('noScroll');
});
    // Close menu languages.
$(".menu-global").click(function (e) {
    $(".menu-global").fadeOut(500);
    $('body').removeClass('noScroll');
    if ($(".menu-global").attr('allinonemodal') === 'show') {
        if ($('.modal-backdrop.fade.show').length === 0) $('body').append('<div class="modal-backdrop fade show"></div>');
        $('#allinonemodal').modal('show');
        $(".menu-global").attr('allinonemodal', 'none');
    }
});

$(".menu-global .button-closed").click(function (e) {
    $(".menu-global").fadeOut(500);
    $('body').removeClass('noScroll');
    if ($(".menu-global").attr('allinonemodal') === 'show') {
        if ($('.modal-backdrop.fade.show').length === 0) $('body').append('<div class="modal-backdrop fade show"></div>');
        $('#allinonemodal').modal('show');
        $(".menu-global").attr('allinonemodal', 'none');
    }
});

$('#allinonemodal').on('hidden.bs.modal', function () {
    $('.modal-backdrop.fade.show').remove();
    $('body').attr('style', '');
    $('#comparedetailModal').find('.modal-dialog').removeClass("side-model-w").removeClass("modal-right");
});

$(document).ready(function () {
    /**auto hide link/menu item if href none**/
    $('.nav-item .nav-link.link[href="#"]').each(function () {
        $(this).parent().addClass('d-none');
    });
    /**auto hide link if href none**/
    /**class added for footer cookie */
    $('a.foot-policy[href="javascript:cookiesSetting();"]').each(function () {
        $(this).addClass('footer_cookielink');
    });
    /**change svg color in img tag**/
    $('img.svg[src$=".svg"], .footer-social-icon img[src$=".svg"]').each(function (index, img) {
        var imgID = img.id;
        var imgClass = img.className;
        var imgURL = img.src;

        fetch(imgURL).then(function (response) {
            return response.text();
        }).then(function (text) {

            var parser = new DOMParser();
            var xmlDoc = parser.parseFromString(text, "text/xml");

            // Get the SVG tag, ignore the rest
            var svg = xmlDoc.getElementsByTagName('svg')[0];

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                svg.setAttribute('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                svg.setAttribute('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            svg.removeAttribute('xmlns:a');

            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
            if (!svg.getAttribute('viewBox') && svg.getAttribute('height') && svg.getAttribute('width')) {
                svg.setAttribute('viewBox', '0 0 ' + svg.getAttribute('height') + ' ' + svg.getAttribute('width'))
            }

            // Replace image with new SVG
            if (img.parentNode) img.parentNode.replaceChild(svg, img);

        });

    });
    /**change svg color in img tag**/
});


module.exports = basecustomMain;
